import {
  FleetWarehouseContactFormValues,
  FleetWarehouseDetailFormValues,
  FleetWarehouseEditFormValues,
  FleetWarehouseSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  FLEET WAREHOUSE EDIT
---------------------------------------------------------------------------------------------*/

export const initialFleetWarehouseEditForm: FleetWarehouseEditFormValues = {
  name: null,
  image: null,
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: "",
  addressState: "",
  addressLatitude: null,
  addressLongitude: null,
  contacts: [],
};

export const initialFleetWarehouseContactForm: FleetWarehouseContactFormValues =
  {
    contactId: null,
  };

/*-------------------------------------------------------------------------------------------
  FLEET WAREHOUSE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetWarehouseSearchForm: FleetWarehouseSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
    FLEET WAREHOUSE DETAILS
---------------------------------------------------------------------------------------------*/

export const initialFleetWarehouseDetailForm: FleetWarehouseDetailFormValues = {
  id: null,
  name: null,
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: "",
  addressState: "",
  addressLatitude: null,
  addressLongitude: null,
  contacts: [],
};
